<div class="row m-0 mb-4">
  <div class="col-md-12 col-lg-8 main-page">
    <span class="title font-extrabold">{{title}}</span>
    <div class="d-flex justify-content-between">
      <span class="color-blue">{{author}}</span>
      <span class="color-blue">{{lastUpdated}}</span>
    </div>
    <div class="w-100 ql-container ql-snow" style="border: none; height: auto;">
      <div class="w-100 content ql-editor" [innerHTML]="content"></div>
    </div>
    <div class="page d-flex justify-content-between">
      <span *ngIf="previousNews !== 0" class="next-page color-blue d-flex justify-content-start"
        (click)="getMainNews(previousNews)"><span class="material-icons">
          west
        </span> Previous News</span>
      <span *ngIf="nextNews !== 0" class="next-page color-blue d-flex justify-content-end"
        (click)="getMainNews(nextNews)">Next News <span class="material-icons">
          east
        </span></span>
    </div>
  </div>
  <div class="col-md-12 col-lg-4 archive">
    <span class="title-archive font-extrabold">Archive</span>
    <div class="search">
      <mat-form-field appearance="outline" class=" w-100">
        <input matInput placeholder="Search" maxlength="50" (keydown)="getListNews()" [(ngModel)]="search">
        <mat-hint align="end">{{search.length || 0}} / 50</mat-hint>
      </mat-form-field>
    </div>
    <mat-card class="p-4">
      <div *ngFor="let item of listNews" class="mb-3">
        <span class="name font-extrabold" (click)="redirectTo(item.id)">{{item.title}}</span>
        <div class="d-flex justify-content-between">
          <span class="author">{{item.author}}</span>
          <span class="author">{{item.lastUpdated}}</span>
        </div>
        <div class="mt-2">
          <span class="content-limit" style="-webkit-box-orient: vertical;">{{item.description}}</span>
        </div>
      </div>
      <div class="paging">
        <ng-container *ngIf="totalPages <= 5">
          <div *ngFor="let item of counter(totalPages); let i = index" class="circle-number" (click)="paging(i)"
            [ngClass]="{'select-page': i === page}">
            <span>{{i + 1}}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="totalPages > 5">
          <div class="circle-number" (click)="paging(0)" [ngClass]="{'select-page': page === 0}">
            <span>1</span>
          </div>
          <div *ngIf="page > 2">...</div>
          <ng-container *ngIf="page <= 1">
            <div class="circle-number" (click)="paging(1)" [ngClass]="{'select-page': page === 1}">
              <span>2</span>
            </div>
            <div class="circle-number" (click)="paging(2)" [ngClass]="{'select-page': page === 2}">
              <span>3</span>
            </div>
          </ng-container>
          <ng-container *ngIf="page > 1 && page < totalPages - 2">
            <div class="circle-number" (click)="paging(page - 1)">
              <span>{{page}}</span>
            </div>
            <div class="circle-number select-page" (click)="paging(page)">
              <span>{{page + 1}}</span>
            </div>
            <div class="circle-number" (click)="paging(page + 1)">
              <span>{{page + 2}}</span>
            </div>
          </ng-container>
          
          <div *ngIf="page < totalPages - 3">...</div>
          <ng-container *ngIf="page >= totalPages - 2">
            <div class="circle-number" (click)="paging(totalPages - 3)" [ngClass]="{'select-page': page === totalPages - 3}">
              <span>{{totalPages - 2}}</span>
            </div>
            <div class="circle-number" (click)="paging(totalPages - 2)" [ngClass]="{'select-page': page === totalPages - 2}">
              <span>{{totalPages - 1}}</span>
            </div>
          </ng-container>
          <div class="circle-number" (click)="paging(totalPages - 1)" [ngClass]="{'select-page': page === totalPages - 1}">
            <span>{{totalPages}}</span>
          </div>
        </ng-container>
      </div>
    </mat-card>
  </div>
</div>